import styled from 'styled-components';

export const TabsWrapper = styled.div`
  padding: 56px 0 6px;
  @media ${(props) => props.theme.device.mobileL} {
    width: calc(var(--full-width) - 16px);
  }
`;

export const MainSection = styled.div`
  padding-bottom: 64px;
`;

export const VideoContainer = styled.div`
  position: relative;
  min-height: 550px;
  width: 100%;
  margin-bottom: 20px;
`;

export const ActivityInfo = styled.div`
  color: ${(props) => props.theme.colors.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.midGray};
`;

export const ActivityInfoWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 20px 0;
  color: ${(props) => props.theme.colors.textPrimary};

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }
`;

export const SocialIconsWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;

  @media ${(props) => props.theme.device.mobileL} {
    width: 100%;
  }
`;

export const VideoSocialWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;

  div:first-child {
    align-items: center;
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;

    div:first-child {
      margin-right: 10px;
    }
  }
`;

export const TagContainer = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.white};
  padding: 20px 0;

  > div:first-child {
    margin-bottom: 10px;
  }
`;

export const ActivitiesTitle = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};
  padding: 15px;
  text-align: center;
  font-size: 1.4rem;
`;

export const ProductCourseHeader = styled.div`
  align-items: center;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 12px;

  font-size: 12px;

  span {
    span {
      margin-right: 6px;
    }
  }
`;

export const ProductCourseHeaderLength = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const ProductCourseHeaderDuration = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
  align-items: center;
  color: ${(props) => props.theme.colors.textSecondary};

  > div {
    width: fit-content;
  }
`;

export const ProductCourseElementCounter = styled.div`
  margin-right: 5px;
  font-size: 12px;
  width: 14px;
  text-align: center;
  color: ${(props) => props.theme.colors.brownGrey};
`;

export const ProductCoursesListCount = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.textPrimary};

  > div {
    width: fit-content;
    width: auto;
  }

  > div:first-child {
    margin-right: 10px;
  }
`;

export const Social = styled.div`
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.themeColor
      : props.theme.colors.textSecondary};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: ${(props) => (props.socialTop ? '50px' : 'unset')};

  @media ${(props) => props.theme.device.mobileL} {
    margin-left: ${(props) => (props.socialTop ? '0' : 'unset')};
    align-self: ${(props) => (props.socialTop ? 'baseline' : 'unset')};
  }

  > span {
    font-size: ${(props) => (props.socialTop ? '25px' : '20px')};
    margin-right: 9px;
  }
  div,
  span {
    cursor: ${(props) => (props.socialTop ? 'default' : 'pointer')};
    transition: ${(props) => props.theme.constants.transitionBase};
  }
  &:hover {
    div,
    span {
      opacity: ${(props) => (props.socialTop ? '1' : '0.6')};
    }
  }
`;

export const Description = styled.div`
  color: ${(props) => props.theme.colors.brownGrey};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 18px;
`;

export const Like = styled.div`
  > div {
    &:nth-child(2) {
      margin-left: 15px;
    }
  }
`;

export const CourseNotAvailable = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;

  > div {
    line-height: 1.17;

    @media ${(props) => props.theme.device.mobileL} {
      font-size: 22px;
    }
  }
`;
